import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon, XCircleIcon } from 'lucide-react';
const isForYou = ['Tienes entre 16 y 40 años y sientes que estás desperdiciando tu potencial.', 'Luchas contra la adicción a la pornografía o el scroll compulsivo de redes sociales.', 'Sufres de neblina mental, fatiga constante y falta de dirección en la vida.', 'Sabes que dentro de ti hay un "Máximo Aquiles" esperando a ser liberado.'];
const notForYou = ['Buscas una "solución mágica" sin sudar ni esforzarte.', 'Prefieres quejarte de tus circunstancias antes que tomar acción.', 'No estás dispuesto a sacrificar la comodidad de tu sofá por 21 días.'];
export function TargetAudience() {
  return <section className="py-12 sm:py-16 lg:py-24 relative bg-dark-bg bg-noise" data-id="element-157">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-158">
        <div className="grid lg:grid-cols-2 gap-6 sm:gap-8 lg:gap-12" data-id="element-159">
          {/* IS FOR YOU */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} className="glass-card p-5 sm:p-8 lg:p-10 border-t-4 border-t-gold" data-id="element-160">
            <h2 className="text-xl sm:text-2xl lg:text-3xl font-bold text-white mb-6 sm:mb-8" data-id="element-161">
              ESTO ES PARA TI SI...
            </h2>
            <ul className="space-y-4 sm:space-y-6" data-id="element-162">
              {isForYou.map((item, i) => <li key={i} className="flex items-start gap-3 sm:gap-4" data-id="element-163">
                  <CheckCircle2Icon className="w-5 h-5 sm:w-6 sm:h-6 text-gold shrink-0 mt-0.5 sm:mt-1" data-id="element-164" />
                  <span className="text-sm sm:text-base lg:text-lg text-gray-300 leading-relaxed" data-id="element-165">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>

          {/* NOT FOR YOU */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} className="bg-dark-surface border border-dark-border p-5 sm:p-8 lg:p-10 opacity-80" data-id="element-166">
            <h2 className="text-xl sm:text-2xl lg:text-3xl font-bold text-gray-400 mb-6 sm:mb-8" data-id="element-167">
              ESTO <span className="text-red-urgent" data-id="element-168">NO</span> ES PARA TI SI...
            </h2>
            <ul className="space-y-4 sm:space-y-6" data-id="element-169">
              {notForYou.map((item, i) => <li key={i} className="flex items-start gap-3 sm:gap-4" data-id="element-170">
                  <XCircleIcon className="w-5 h-5 sm:w-6 sm:h-6 text-red-dark shrink-0 mt-0.5 sm:mt-1" data-id="element-171" />
                  <span className="text-sm sm:text-base lg:text-lg text-gray-500 leading-relaxed" data-id="element-172">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}